import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSankeyAxis: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sankey-axis"><path d="M3.75 3.75V20.25H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6.25 7C11.8922 7 13.6078 15 19.25 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.25 6C13.6078 6 11.8922 12 6.25 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.25 10.25C13.6078 10.25 11.8922 17.25 6.25 17.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSankeyAxis;
